import script from "./TressSearchInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressSearchInput.vue?vue&type=script&lang=ts&setup=true"

import "./TressSearchInput.vue?vue&type=style&index=0&id=b7c018d6&lang=scss"

const __exports__ = script;

export default __exports__